import(/* webpackMode: "eager" */ "/home/ubuntu/download/6980d1b5921dc90014148890/bookreview_hub/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6980d1b5921dc90014148890/bookreview_hub/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6980d1b5921dc90014148890/bookreview_hub/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6980d1b5921dc90014148890/bookreview_hub/src/components/ui/AppImage.tsx");
